import React from "react";
import {connect} from "react-redux";
import {
    Alert,
    Button,
    Card,
    Col,
    Container,
    Pagination,
    Row,
    Table
} from "react-bootstrap";
import Skeleton from "react-loading-skeleton/lib";
import {REMOVE_INVOICE_LIST} from "../../actions/actionsTypes";
import {retrieveInvoiceList} from "../../actions/actionCreators";
import { push } from 'connected-react-router'
import {store} from "../../store";

const persianDate = require('persian-date');
const mapStateToProps = state => ({ ...state });
const mapDispatchToProps = dispatch => ({
    retrieveInvoiceList,
    removeList: ()=>{dispatch({type: REMOVE_INVOICE_LIST})}
});
class InvoiceListPage extends React.Component{
    constructor(props) {
        super(props);

        this.props.retrieveInvoiceList();
    }

    componentWillUnmount() {
        this.props.removeList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            auth: {
                authenticated
            }
        } = prevProps
        const {
            retrieveInvoiceList,
            auth: {
                authenticated: authenticatedNew,
            }
        } = this.props

        if (authenticated !== authenticatedNew)
            retrieveInvoiceList()
    }

    render() {

        let paginationItems = [];
        if (this.props.order.invoiceList && this.props.order.invoiceList.last_page > 1)
            for (let number = 1; number <= this.props.order.invoiceList.last_page; number++) {
                paginationItems.push(
                    <Pagination.Item key={number}
                                     onClick={()=>this.props.retrieveInvoiceList(number)}
                                     active={number === this.props.order.invoiceListCurrentPage}>
                        {number}
                    </Pagination.Item>,
                );
            }

        const Status = (props)=>{
                switch (props.s) {
                    case 1:
                        return 'ثبت شده';
                    case 2:
                        return 'پذیرش راننده';
                    case 4:
                        return 'شروع باربری';
                    case 5:
                        return 'پایان باربری';
                    case 6:
                        return 'پرداخت شده';
                    case 7:
                        return 'لغو شده';

                    default:
                        return <Skeleton/>;

                }
        }

        return (
            <Container>
              <Row className='justify-content-center' style={{marginTop: 20}}>
                  <Col sm={12} xs={12} md={12} lg={11}>
                      <Card>
                          <Card.Body>
                              <Card.Title as={'h4'}>سفارشات من</Card.Title>

                              <Table responsive borderless striped={!!this.props.order.invoiceList} className='text-center table-hover'>
                                  {
                                      this.props.order.invoiceList && this.props.order.invoiceList.data.length === 0 ?
                                          <thead>
                                          <tr>
                                              <th>در حال حاظر هیچ سفارش ثبت شده‌ای ندارید.</th>
                                          </tr>
                                          </thead>
                                          :
                                          <thead>
                                          <tr>
                                              <th># شماره</th>
                                              <th className="hide-small-screen">وضعیت</th>
                                              <th>مبدا</th>
                                              <th>مبلغ</th>
                                              <th>زمان بارگیری</th>
                                          </tr>
                                          </thead>
                                  }

                                  <tbody>

                                  {this.props.order.invoiceList ? this.props.order.invoiceList.data.map(row => {
                                          return (
                                              <>
                                                  <div className="display-small-screen"> <td colSpan={4}> وضعیت: <Status s={row.status}/></td> </div>

                                                  <tr onClick={()=>{store.dispatch(push(`/invoice/${row.id}/tracking`))}}
                                                      style={{cursor: "pointer"}}>
                                                      <td> # {row.id || <Skeleton/>} </td>
                                                      <td className="hide-small-screen"> <Status s={row.status}/> </td>
                                                      <td className='address'> {row.origin_address.description || <Skeleton/>} </td>
                                                      <td> {row.price ?
                                                          Number(Math.floor(row.price / 10)).toLocaleString() + " تومان"
                                                          : <Skeleton/>} </td>
                                                      <td> {row.moving_time ?
                                                          new persianDate(new Date(row.moving_time))
                                                              .format("DD MMMM YYYY ساعت HH:mm")
                                                          : <Skeleton/>} </td>
                                                  </tr>
                                              </>

                                          );
                                      })

                                      :
                                      <>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>
                                              </tr>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>
                                          </tr>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td>  <Skeleton/></td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>
                                          </tr>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>
                                          </tr>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>
                                          </tr>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td>  <Skeleton/></td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>
                                          </tr>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>
                                          </tr>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>

                                          </tr>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>

                                          </tr>

                                          <tr>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td> <Skeleton/> </td>
                                              <td className='hide-small-screen'> <Skeleton/> </td>
                                          </tr>
                                      </>
                                  }


                                  </tbody>
                              </Table>

                              <Pagination style={{margin: "0 auto", width: "min-content"}}>
                                  {paginationItems}
                              </Pagination>
                          </Card.Body>
                      </Card>
                  </Col>
              </Row>
            </Container>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceListPage)
